import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout.jsx';
import Home from './pages/Home.jsx';
import About from './pages/About.jsx';
import TakTil from './pages/TakTil.jsx';
import WhoWeHelp from './pages/WhoWeHelp.jsx';
import SupportUs from './pages/SupportUs.jsx';
import News from './pages/News.jsx';
import Events from './pages/Events.jsx';
import Contact from './pages/Contact.jsx';
import Documents from './pages/Documents.jsx';
import TfdiPaaNettet from './pages/TfdiPaaNettet.jsx';
import Samarbejde from './pages/Samarbejde.jsx';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="om-os" element={<About />} />
        <Route path="sponsorer" element={<TakTil />} />
        <Route path="tak-til" element={<Navigate to="/sponsorer" replace />} />
        <Route path="samarbejde" element={<Samarbejde />} />
        <Route path="tfdi-paa-nettet" element={<TfdiPaaNettet />} />
        <Route path="hvem-hjaelper-vi" element={<WhoWeHelp />} />
        <Route path="soeg-hjaelp" element={<Navigate to="/kontakt#soeg-hjaelp" replace />} />
        <Route path="stoet-os" element={<SupportUs />} />
        <Route path="nyheder" element={<News />} />
        <Route path="nyheder/events" element={<Events />} />
        <Route path="events" element={<Events />} />
        <Route path="kontakt" element={<Contact />} />
        <Route path="dokumenter-og-regnskab" element={<Documents />} />
        <Route path="dokumenter" element={<Navigate to="/dokumenter-og-regnskab" replace />} />
      </Route>
    </Routes>
  );
}
